import React from 'react';
import CommonSlider from "../../../common/CommonSlider.jsx";
import CommonField from "../ag_chart/components/CommonField.jsx";
import get from 'lodash/get';

function SliderSetting(props) {
  const { attr, prefix = '', label, min = 0, max = 50, step = 1, setAttribute, selectedObject, unit, disabled = false, defaultValue } = props;
  const fullAttr = [prefix, attr].filter(Boolean).join('.');
  return (
    <CommonField label={label} {...props} attr={fullAttr}>
      <CommonSlider
        value={get(selectedObject, fullAttr) ?? defaultValue}
        min={min}
        max={max}
        onChange={v => setAttribute(fullAttr, v)}
        step={step}
        unit={unit}
        disabled={disabled}
      />
    </CommonField>
  )
}

export default SliderSetting;